import * as api from "@/api/williams/contractors";
import { getWeldingSpecialists } from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { useQuery, useQueryClient } from "react-query";

export function useContractor(contractorId?: string) {
  const client = useQueryClient();
  const id = contractorId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.contractor.single(id),
    queryFn: async () => {
      const data = await api.getContractorById(id);
      await client.prefetchQuery(queryKeys.user.weldingSpecialists(), getWeldingSpecialists);
      return data;
    },
  });
}
